import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { setFormState } from "../../redux/store/emailLoginSlice";
import { useAuth0 } from "@auth0/auth0-react";
import { Button } from "antd";

const EmailLogin = () => {
  const dispatch = useDispatch();
  const formState = useSelector((state) => state.emailLogin.formState);
  const { loginWithPopup } = useAuth0();

  const handleStateChange = (newState) => {
    dispatch(setFormState(newState));
  };

  const handleLogin = async () => {
    try {
      await loginWithPopup({
        authorizationParams: {
          screen_hint: formState === "signup" ? "signup" : "login",
          prompt: "login"
        }
      });
    } catch (error) {
      console.error("Login error:", error);
    }
  };

  return (
    <div
      style={{
        width: "100%",
        maxWidth: "400px",
        padding: "24px 24px 0px 24px",
      }}
    >
      <Button
        type="primary"
        onClick={handleLogin}
        style={{
          width: "100%",
          height: "40px",
          backgroundColor: "var(--primary-color)",
          color: "white",
        }}
      >
        {formState === "signup" ? "Sign Up" : "Log In"}
      </Button>
    </div>
  );
};

export default EmailLogin;
